
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"100","height":"100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_2364_28935)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50 91.667c23.012 0 41.667-18.655 41.667-41.667S73.012 8.333 50 8.333 8.333 26.988 8.333 50 26.988 91.667 50 91.667zm19.613-47.054a4.167 4.167 0 00-5.893-5.893L45.833 56.607l-5.387-5.387a4.167 4.167 0 00-5.892 5.893l8.333 8.333a4.167 4.167 0 005.892 0l20.834-20.833z","fill":"#28BF7A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2364_28935"}},[_c('rect',{attrs:{"width":"100","height":"100","rx":"4","fill":"#fff"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      